export default __webpack_public_path__ + "static/media/unsuccessful.ec098a6e.svg";